import React from "react";
import { useLocale } from "hooks";
import { useStyles } from "styling/mainStyles";
import { Lightbox } from "components/common";

const DeleteText = () => {
  const classes = useStyles();
  const { localeState } = useLocale();
  const { locale } = localeState;

  return (
    <div className={classes.infoContent}>
      <p>
        You can delete all your data from from the server by following these
        simple steps:
      </p>

      <p>
        <b>1. Open the app navigation and go to the 'My Account' section.</b>
      </p>

      <p>
        <b>2. Tap the 'Delete Account' button.</b>
      </p>

      <p>
        <b>
          3. Confirm that you are sure you want to delete your accound and data.
        </b>
      </p>
      <p>That's it! All your data will be permanently deleted.</p>
      <Lightbox className="lightbox-img" imgSrc={`img/nav_${locale}.jpg`} />
      <Lightbox className="lightbox-img" imgSrc={`img/account_${locale}.jpg`} />
      <Lightbox
        className="lightbox-img"
        imgSrc={`img/delete_confirmation_${locale}.jpg`}
      />
    </div>
  );
};

export default DeleteText;
